import { Component, OnInit } from '@angular/core';
import { MetamanagerService } from '../metamanager.service';
import { InitScripts } from '../app.constants';

@Component({
  selector: 'app-copyrights',
  templateUrl: './copyrights.component.html',
  styleUrls: ['./copyrights.component.css']
})
export class CopyrightsComponent implements OnInit {
  constructor(private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Copyrights Detail | sarvadhnya.com",
      "आदिकरण श्री दत्तात्रेय प्रभू, श्री गुरुवर्य आणि अखिल परमार्ग",
      "");
  }

}
